import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notepad_tool = _resolveComponent("notepad-tool")!
  const _component_Calculator = _resolveComponent("Calculator")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_notepad_tool),
    _createVNode(_component_Calculator, {
      type: 'basic-calculator',
      title: _ctx.$t('toolbar.calc_basic'),
      width: 600,
      height: 600
    }, null, 8, ["title"]),
    _createVNode(_component_Calculator, {
      type: 'scientific-calculator',
      title: _ctx.$t('toolbar.calc_sci'),
      width: 600,
      height: 600
    }, null, 8, ["title"]),
    _createVNode(_component_Calculator, {
      type: 'graphing-calculator',
      title: _ctx.$t('toolbar.calc_graph'),
      width: 600,
      height: 600
    }, null, 8, ["title"])
  ]))
}